import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import MuiSwitch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
const SurveySwitch = ({ value, onChange, name, color = 'primary', minLabel = 'Imperial', maxLabel = 'Metric', disabled, }) => {
    const booleanValue = Boolean(Number(value));
    const [checked, setChecked] = useState(booleanValue);
    useEffect(() => {
        if (checked !== booleanValue) {
            setChecked(booleanValue);
            onChange(booleanValue ? '1.0' : '0.0');
        }
    }, [value]);
    const handleChange = (event) => {
        const newChecked = event.target.checked;
        setChecked(newChecked);
        onChange(newChecked ? '1.0' : '0.0');
    };
    return (_jsx(FormControl, Object.assign({ component: "fieldset", disabled: disabled }, { children: _jsxs(Box, Object.assign({ display: "flex", alignItems: "center" }, { children: [_jsx(Typography, Object.assign({ variant: "body2", sx: { minWidth: 60, textAlign: 'right', pr: 1 } }, { children: minLabel })), _jsx(MuiSwitch, { checked: checked, onChange: handleChange, name: name, color: color, disabled: disabled }), _jsx(Typography, Object.assign({ variant: "body2", sx: { minWidth: 60, textAlign: 'left', pl: 1 } }, { children: maxLabel }))] })) })));
};
export default SurveySwitch;
